import { render, staticRenderFns } from "./character.vue?vue&type=template&id=e3b39ee8&scoped=true"
import script from "./character.vue?vue&type=script&lang=js"
export * from "./character.vue?vue&type=script&lang=js"
import style0 from "./character.vue?vue&type=style&index=0&id=e3b39ee8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b39ee8",
  null
  
)

export default component.exports